<div class="early-container">
  <div class="loading-overlay" *ngIf="loading">
    <div class="loading-spinner"></div>
    <div class="loading-text">加载中...</div>
  </div>
   <div class="grid-data">
        <ng-container  *ngFor="let item of Contract_Management_data; let i = index">
          <div [class]="handleClass(item) + ' grid-item'" *ngIf="item.show">
            <ng-container *ngIf="item.type == 'more'">
              <div>
                    <div class="child-item" *ngFor="let child of item | keyvalue">
                      <ng-container *ngIf="child.key!='type'&&child.key!='show'">
                          <div class="title" *ngIf="child.key!='title'">{{child.key}} <span class="day" *ngIf="item.titleShowDay">(days)</span></div>
                          <div class="number" *ngIf="child.value!='Contract Key Date'&&child.value!='Contract Sectional Completion Date'">{{child.value?child.value:'--'}}  <span class="day" *ngIf="item.showDay">days</span></div>
                      </ng-container>
                </div>
              </div>
            </ng-container>
            <div class="child-item" *ngIf="item.type != 'more'" >
              <div class="title">{{item.title}} <span class="day" *ngIf="item.titleShowDay">(days)</span></div>
              <div class="number">{{item.value}} <span class="day" *ngIf="item.showDay">days</span></div>
              <div *ngIf="item.remask" class="remask">{{item.remask}}</div>
            </div>
          </div>
        </ng-container>
      </div>
</div>

